import { createStyles, makeStyles, Typography } from '@material-ui/core';
import sicrediColor from 'assets/styles/default.scss';
import React from 'react';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      color: sicrediColor.secondarySicrediDarker,
      fontFamily: '"Nunito", sans-serif',
      fontSize: 14,
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
  })
);

export interface IPageSubtitle {
  subtitle: string;
}

export default function PageSubtitle({ subtitle }: IPageSubtitle) {
  const classes = useStyles();

  return <Typography classes={{ root: classes.root }}>{subtitle}</Typography>;
}
